module.exports = __webpack_public_path__ + "img/1_05.29c74c82.jpg";